import React, { Fragment, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesLbl
} from '../../../../../St/Reports/UseStyle';
//=====================================================================
import SubUnits from '../../subUnits/SubUnits';
import { useTranslation } from "react-i18next";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import { useStylesContainers } from '../../../../../St/comps/UseStyle';
import { Checkbox, colors, FormControlLabel, FormGroup } from '@material-ui/core';
import ItemsImage from '../items-image';
import Button from '../../../../../components/controls/Button';
import ScannerIcon from "@material-ui/icons/Scanner";
import KhamItems from '../KhamItems/KhamItems';
import ItemsComps from '../ItemsComps/ItemsComps';
export default function ItemsForms(props) {

    const {
        AutoOptions,
        items,
        setItems,
        changTField,
        changAutos,
        currUnitList,
        setCurrUnitList,
        valueAutos,
        autos_curr,
        setOpenMulti,
        styl,
        clasui,
        changePurchPrice,
        dataList,
        setDataList,
        onChangeAutoGroupsMain,
        onChangeAutoGroupsSub,
        GroupsSubs,
        groupsMain,
        allItems,
        inputRef,
        confirmDialog,
        setConfirmDialog,
        allow, setAllow, safesVal, chickBarcode,
        khamsItems,
        itemsComms,
        setItemsComms,
        paramsUnit,
        setParamsUnit
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();


    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);
    const handleFocus = (e) => e.target.select();

    const [showPic, setShowPic] = useState(false);

    const stylH = {
        backgroundColor: colors.red[500],
        color: "#fff",
        textAlign: "center",
        whiteSpace: "nowrap",
        fontSize: 12,
        borderLeft: "solid 0.1px blue",
        paddingTop: 1,
        paddingBottom: 1,
    }
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} justifyContent="center" spacing={2}>
                <Grid
                    item
                    container
                    spacing={1}
                    justifyContent='center'
                    lg={12} md={12} sm={12} xs={12}
                >

                    <Grid item lg={3} md={3} sm={4} xs={3}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="id"
                            label={t("forms:product-id")}
                            //className={clasTF.clrBlack}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                            // InputProps={{ className: clasTD.input, readOnly: true }}
                            type="text"
                            name="id"
                            value={items.id}

                            onChange={changTField("id")}
                        />
                    </Grid>

                    <Grid item lg={7} md={7} sm={7} xs={6}>
                        <TextField
                            // inputRef={inputRef}
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="addbarcode"
                            label={t("forms:barcode")}
                            type="text"
                            name="barcode"
                            value={items.barcode}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        chickBarcode();
                                    }
                                },
                            }}
                            onFocus={handleFocus}
                            autoComplete="off"
                            onChange={changTField("barcode")}
                        />
                    </Grid>

                    <Grid item container lg={2} md={2} sm={2} xs={3} >
                        <Grid item>

                            <Button
                                disabled={false}
                                variant="contained"
                                startIcon={<ScannerIcon />}
                                size="large"
                                style={{ backgroundColor: "#f18584", borderRadius: 0 }}
                                className={[clasui.buttonB]}
                                onClick={() => setOpenMulti(true)}
                            >
                                {"Barcode"}
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="symbol"
                            label={t("forms:product-name-ar")}
                            className={clasTF.rootCust}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("nameEN").focus();
                                    }
                                },
                            }}
                            type="text"
                            name="symbol"
                            value={items.symbol}
                            onFocus={handleFocus}
                            onChange={changTField("symbol")}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameEN"
                            label={t("forms:product-name-en")}
                            className={clasTF.rootCust}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("purch_price").focus();
                                    }
                                },
                            }}
                            type="text"
                            name="nameEN"
                            value={items.nameEN}
                            onChange={changTField("nameEN")}
                        />
                    </Grid>
                    <Grid
                        item
                        className={clasTF.tool}
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        style={{
                            padding: "0px",
                            color: "#81007f",
                            textAlign: "-webkit-center",
                            marginBottom: 5
                        }}
                    >
                        <IconButton
                            color="inherit"
                            style={{
                                padding: "10px",
                                color: "#81007f",
                                border: "solid 0.1px",
                                borderRadius: 50,
                            }}
                            aria-label="open drawer"
                        >
                            <AddIcon />
                        </IconButton>
                    </Grid>

                    {AutoOptions?.permType?.id === 3 ? (
                        <>
                            <Grid item className={clasTF.tool} lg={5} md={10} sm={10} xs={10} >
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueAutos?.group_Main}
                                    labelPlacement=""
                                    onChange={(event, newValue) => {
                                        onChangeAutoGroupsMain("group_Main", newValue);
                                    }}
                                    id="groups1"
                                    size="small"
                                    options={groupsMain}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    // style={{  }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={"المجموعة الرئيسية"}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item className={clasTF.tool} lg={5} md={10} sm={10} xs={10} >
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueAutos?.group_Sub}
                                    labelPlacement=""
                                    onChange={(event, newValue) => {
                                        onChangeAutoGroupsSub("group_Sub", newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={GroupsSubs ?? []}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    // style={{  }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={"المجموعة الفرعية"}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                        />
                                    )}
                                />
                            </Grid>
                        </>
                    ) :
                        (
                            <Grid item className={clasTF.tool} lg={5} md={10} sm={10} xs={10} >
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueAutos.group_id}
                                    labelPlacement=""
                                    onChange={(event, newValue) => {
                                        changAutos("group_id", newValue);
                                    }}
                                    id="group1"
                                    size="small"
                                    options={AutoOptions.Groupst}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }

                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t("forms:product-group")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                        />
                                    )}
                                />
                            </Grid>
                        )}




                    <Grid item className={clasTF.tool} lg={5} md={6} sm={12} xs={12}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.branch}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("branch", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions.Branches}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:branch")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="purch_price"
                            label={t("forms:purch-price")}
                            // InputProps={{ className: clasTD.input }}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("sale_price").focus();
                                    }
                                },
                            }}
                            type="text"
                            name="purch_price"
                            value={items.purch_price}
                            onFocus={handleFocus}
                            onChange={changTField("purch_price")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }}  >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="sale_price"
                            label={t("forms:sale-price")}
                            style={{ marginBottom: 5 }}
                            //InputProps={{ className: clasTD.input }}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("min_sale_price").focus();
                                    }
                                },
                            }}
                            type="text"
                            name="sale_price"
                            value={items.sale_price}
                            onFocus={handleFocus}
                            onChange={changTField("sale_price")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={4} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="min_sale_price"
                            label={t("forms:little-sale-price")}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("Distributor_price").focus();
                                    }
                                },
                            }}
                            type="text"
                            name="min_sale_price"
                            value={items.min_sale_price}
                            onFocus={handleFocus}
                            onChange={changTField("min_sale_price")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Distributor_price"
                            label={t("moz-price")}
                            //InputProps={{ className: clasTD.input }}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{
                                className: claslbl.clrBlackTxt,
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        document.getElementById("jomla_price").focus();
                                    }
                                },
                            }}
                            type="text"
                            name="Distributor_price"
                            value={items.Distributor_price}
                            onFocus={handleFocus}
                            onChange={changTField("Distributor_price")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="jomla_price"
                            label={t("forms:wholesale-price")}
                            // InputProps={{ className: clasTD.input }}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            type="text"
                            name="jomla_price"
                            value={items.jomla_price}
                            onFocus={handleFocus}
                            onChange={changTField("jomla_price")}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.type}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("type", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={autos_curr.currType}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:product-type")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="amount_disc"
                            label={t("مبلغ الخصم")}
                            disabled={items.discount > 0 ? true : false}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            type="number"
                            name="jomla_price"
                            value={items?.amount_disc}
                            onChange={changTField("amount_disc")}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="amount_disc"
                            label={t("نسبة الخصم")}
                            disabled={items.amount_disc > 0 ? true : false}
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            type="number"
                            name="discount"
                            value={items?.discount}
                            onChange={changTField("discount")}
                        />
                    </Grid>
                    <Grid item className={clasTF.tool} lg={7} md={7} sm={7} xs={7} style={{ marginBottom: "0.3rem" }} >
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.tax_group}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("tax_group", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions.tax_groups}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:tax-group")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item className={clasTF.tool} lg={5} md={5} sm={5} xs={5} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="tax"
                            label=" % "
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: clasTD.clrBlackTxt, readOnly: true }}
                            type="text"
                            name="tax"
                            value={items.tax}
                        /*onChange={changTField('tax')}*/
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.unit}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("unit", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions.Units}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:default-unit")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="prody_date"
                            label={t("forms:procuction-date")}
                            InputLabelProps={{ className: clasTD.clrBlackLbl }}
                            InputProps={{ className: clasTD.clrBlackTxt }}
                            type="date"
                            format="YYYY-MM-DD"
                            name="prody_date"
                            value={items.prody_date}
                            onChange={changTField("prody_date")}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="expiry_date"
                            label={t("forms:expiry-date")}
                            InputLabelProps={{ className: clasTD.clrBlackLbl }}
                            InputProps={{ className: clasTD.clrBlackTxt }}
                            type="date"
                            format="YYYY-MM-DD"
                            name="expiry_date"
                            value={items.expiry_date}
                            onChange={changTField("expiry_date")}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        fullWidth
                                        checked={items?.is_tab3_curr}
                                        onChange={(e) => {
                                            setItems({
                                                ...items,
                                                is_tab3_curr: e.target.checked ? 1 : 0,
                                            });
                                            console.log("the currl is", items);
                                        }}
                                        name="is_tab3_curr"
                                    />
                                }
                                size="small"
                                color="primary"
                                fontSize="small"
                                label="ضريبة تبغ"
                                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                InputProps={{ className: clasTD.clrBlackTxt }}
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={6} style={{ marginBottom: "0.3rem" }} >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    fullWidth
                                    checked={showPic}
                                    onChange={(e) => {
                                        setShowPic(e.target.checked)
                                    }}
                                />
                            }
                            size="small"
                            color="primary"
                            fontSize="small"
                            label="اضافة صورة"
                            InputLabelProps={{ className: claslbl.clrBlackLbl }}
                            InputProps={{ className: clasTD.clrBlackTxt }}
                        />
                    </Grid>
                    {showPic && (<Grid item container lg={12} md={12} tyle={{ marginBottom: "0.3rem" }} className={clsConts.rootup}>

                        <Grid
                            item
                            container
                            style={{ textAlign: "center" }}
                            xs={12}
                            className={[clsConts.subUp, clsConts.subUpL]}
                        >
                            <ItemsImage
                                {...{
                                    items,
                                    setItems,
                                }}
                            />
                        </Grid>
                    </Grid>)}
                    {items?.type == 3 && (
                        <ItemsComps

                            {...{
                                items, setItems,khamsItems, itemsComms, setItemsComms,setConfirmDialog
                            }}
                        />
                    )
                    }
                    {/* {items?.type == 3 && (
                        <KhamItems
                            {...{
                                AutoOptions,
                                khamItemsList: allItems?.filter(c => c.type == 2),
                                dataList,
                                setDataList,
                                changePurchPrice,
                                items,
                                setItems,
                            }}
                        />
                    )
                    } */}

                    <SubUnits
                        {...{
                            items,
                            AutoOptions,
                            units: AutoOptions.Units,
                            currUnitList,
                            setCurrUnitList,
                            confirmDialog,
                            setConfirmDialog,
                            allow, setAllow,itemsComms,
                            paramsUnit,
                            setParamsUnit
                        }}
                    />

                    <Fragment>
                        <Grid container xs={12}>
                            <Grid item xs={4} style={stylH}>
                                {t("quanity")}
                            </Grid>
                            <Grid item xs={4} style={stylH}>
                                {t("safe")}
                            </Grid>
                            <Grid item xs={4} style={stylH}>
                                {t("branch")}
                            </Grid>
                            {safesVal?.map((d) => {
                                return (
                                    <Grid
                                        xs={12}
                                        container
                                        item
                                        style={{ direction: "ltr", textAlign: "center", backgroundColor: `${d.Qtys > 0 ? "#00ff00" : "#fff"}` }}
                                    >
                                        <Grid item xs={4}>
                                            {d.Qtys}
                                        </Grid>
                                        <Grid item xs={4}>
                                            {/* {" "} */}
                                            {d.name}
                                        </Grid>
                                        <Grid item xs={4}>
                                            {/* {" "} */}
                                            {d.nameBranch}
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Fragment>

                </Grid>
            </Grid>



        </React.Fragment>
    );

}